export default {
  bind (el, binding) {
    el.style.overflow = 'hidden'
    el.style.display = '-webkit-box'
    el.style.webkitLineClamp = binding.value
    el.style.webkitBoxOrient = 'vertical'
  }
}
